import React from 'react'

function TeamSix() {
    return (
        <div>
            {/* rts team area ten start */}
            <div className="rts-testimonials-area-ten rts-section-gapBottom">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-area-left-ten">
                                <span className="pre-title">Expert Members</span>
                                <h2 className="title">
                                    Meet Our <span>Amazing Team</span>
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-5 mt--30">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            {/* single team area start */}
                            <div className="team-style-ten bg_image">
                                <div className="thumbnail-image-team">
                                    <a href="#" className="thumbnail">
                                        <img src="assets/images/team/tm/01.jpg" alt="team" />
                                    </a>
                                    <ul className="social-team-10">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="body">
                                    <a href="#">
                                        <h5 className="title">Archer Graham</h5>
                                    </a>
                                    <span>Finance Manager</span>
                                </div>
                            </div>
                            {/* single team area end */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            {/* single team area start */}
                            <div className="team-style-ten bg_image">
                                <div className="thumbnail-image-team">
                                    <a href="#" className="thumbnail">
                                        <img src="assets/images/team/tm/02.jpg" alt="team" />
                                    </a>
                                    <ul className="social-team-10">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="body">
                                    <a href="#">
                                        <h5 className="title">Thomas Johnson</h5>
                                    </a>
                                    <span>Finance Manager</span>
                                </div>
                            </div>
                            {/* single team area end */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            {/* single team area start */}
                            <div className="team-style-ten bg_image">
                                <div className="thumbnail-image-team">
                                    <a href="#" className="thumbnail">
                                        <img src="assets/images/team/tm/03.jpg" alt="team" />
                                    </a>
                                    <ul className="social-team-10">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="body">
                                    <a href="#">
                                        <h5 className="title"> Grace Turner</h5>
                                    </a>
                                    <span>Finance Manager</span>
                                </div>
                            </div>
                            {/* single team area end */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
                            {/* single team area start */}
                            <div className="team-style-ten bg_image">
                                <div className="thumbnail-image-team">
                                    <a href="#" className="thumbnail">
                                        <img src="assets/images/team/tm/04.jpg" alt="team" />
                                    </a>
                                    <ul className="social-team-10">
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="fab fa-linkedin-in" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="body">
                                    <a href="#">
                                        <h5 className="title">Victoria Wright</h5>
                                    </a>
                                    <span>Finance Manager</span>
                                </div>
                            </div>
                            {/* single team area end */}
                        </div>
                    </div>
                </div>
            </div>
            {/* rts team area ten end */}
        </div>
    )
}

export default TeamSix